/**
 * URL/filename-safe slug: lowercase ASCII alphanumerics joined by `-`.
 * Sequences of any other character collapse to a single separator; leading
 * and trailing separators are trimmed. Returns `'untitled'` for inputs
 * that contain no alphanumerics so callers always get a usable name.
 */
export function slugify(input: string): string {
  const slug = input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return slug === '' ? 'untitled' : slug;
}
